// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Usuario } from '../comum/usuario.model';
import { Estoque } from './estoque.model';

export class UsuarioEstoque extends BaseResourceModel {
  constructor(
    public id?: number,
    public usuario?: Usuario,
    public estoque?: Estoque,
  ) {
    super();
  }
  static converteJson(json: any): UsuarioEstoque {
    return Object.assign(new UsuarioEstoque(), json);
  }
}
